import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function SubTests() {
  var history = useHistory();
  const sort = 25;
  const activePag = useRef(0);

  const [allSubTest, setAllSubTest] = useState([]);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [subTestName, setSubTestName] = useState("");
  const [subTestPrice, setSubTestPrice] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [testID, setTestId] = useState("");
  const [testDesc, setTestDesc] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);

  function getData() {
    axios
      .get(Baseurl.baseurl3 + "/health/get-all-sub-test")
      .then((res) => {
        console.log("categoiryeueye", res.data);
        setSpinner(false);
        setAllSubTest(res.data.subTest);
        setSearchData(res.data.subTest);
        setData(document.querySelectorAll("#job_data tbody tr"))
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllSubTest(filteredData);
  }

  function addCategory() {
    let testFields = {
      name: subTestName,
      desc: testDesc,
      price: 0,
    };
    axios
      .post(Baseurl.baseurl3 + `/health/create-sub-test`, testFields)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCategory() {
    let testFields = {
      name: subTestName,
      price: 0,
      desc: testDesc,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-sub-test/${testID}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }

  function deleteCategory() {
    axios
      .delete(
        Baseurl.baseurl3 + `/health/delete-sub-test-by-id/${testID}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setShow(true);
    setTestId(val._id);
    setUpdateStatus(true);
    setSubTestName(val.Name);
    // setSubTestPrice(val.Price);
    setTestDesc(val.Description)
  }
   const ReadMore = ({ children }) => {
        const [isReadMore, setIsReadMore] = useState(true);
    
        return (
          <>
            {isReadMore ? children && children.slice(0, 120) : children}
            <span
              onClick={() => {
                setIsReadMore(!isReadMore);
              }}
            >
              {isReadMore ? (
                <b style={{color:"#b30000"}}>{" "}Readmore</b>
              ) : (
                <b style={{color:"#b30000"}}>{" "}Readless</b>
              )}
            </span>
          </>
        );
      };
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Test ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCategory();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add SubTest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
             
              <div className="col-sm-6">
              <label>
                  SubTest Name <span className="text-danger">*</span>
                </label>
                <input
                  value={subTestName}
                  type="text"
                  className="form-control"
                  placeholder="enter Category Name"
                  onChange={(e) => setSubTestName(e.target.value)}
                  required
                />
              </div>

              {/* <div className="col-sm-6">
              <label>
                  SubTest Price<span className="text-danger">*</span>
                </label>
                <input
                  value={subTestPrice}
                  type="text"
                  className="form-control"
                  placeholder="enter subtest price"
                  onChange={(e) => setSubTestPrice(e.target.value)}
                  required
                />
              </div> */}
               <div className="col-sm-6">
              <label>
                  Test Description<span className="text-danger">*</span>
                </label>
                <textarea
                  value={testDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setTestDesc(e.target.value)}
                  required
                />
              </div>
            </div>
          
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);
              setSubTestName("");
              setSubTestPrice("");
            }}
            className="btn btn-primary"
          >
            Add SubTest
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Test Name</strong>
                    </th>
                    <th>
                      <strong>Description</strong>
                    </th>
                    {/* <th>
                      <strong>Test Price</strong>
                    </th> */}

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{fontSize:"13px"}}>
                  {allSubTest &&
                    allSubTest.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>

                        <td>{val.Name}</td>
                        <td>{val.Description.length>119?<ReadMore>{val.Description}</ReadMore>:val.Description}</td>
                        {/* <td>{val.Price}</td> */}

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setTestId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allSubTest && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allSubTest
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default SubTests;
